import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiCollectionRepository,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import { FetteinheitenRechnerZeile } from '../data/fetteinheiten-rechner-zeile';
import { Detail } from '../data/detail';
import { SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL } from '../rohstoffbereitstellung.api';
import { RohstoffbereitstellungQuery } from '../services/query.service';

@Injectable()
export class RohstoffbereitstellungDetailRepository extends ReadonlyHttpApiListRepository<
  Result<Detail[]>,
  RohstoffbereitstellungQuery | undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ROHSTOFFBILANZ_QUERY_DETAIL);
  }

  protected override getLoadPayload(
    params: RohstoffbereitstellungQuery | undefined
  ): Dictionary<unknown> | undefined {
    return params as Dictionary<unknown> | undefined;
  }
}
